export const laoConnections: Record<string, string> = {
  'Manage API keys': 'ຈັດການກະແຈ API',
  'Manage integration access across your businesses.': 'ຈັດການສິດເຊື່ອມຕໍ່ສຳລັບທຸກທຸລະກິດ.',
  'Workspace access': 'ສິດເຂົ້າໃຊ້ທຸລະກິດ',
  'Each key connects to one workspace and follows its assigned member’s permissions.':
    'ແຕ່ລະກະແຈເຊື່ອມຕໍ່ກັບທຸລະກິດດຽວ ແລະ ໃຊ້ສິດຂອງສະມາຊິກທີ່ກຳນົດ.',
  'All workspaces': 'ທຸກທຸລະກິດ',
  'Workspace not found': 'ບໍ່ພົບທຸລະກິດ',
  'Workspace suspended': 'ທຸລະກິດຖືກລະງັບ',
  'Mobile API enabled': 'ເປີດ Mobile API ແລ້ວ',
  'Mobile API disabled': 'ປິດ Mobile API',
  'Copy workspace ID': 'ຄັດລອກລະຫັດທຸລະກິດ',
  'Manage add-ons': 'ຈັດການສ່ວນເສີມ',
  'Reactivate this workspace before creating integration keys.':
    'ເປີດໃຊ້ທຸລະກິດຄືນກ່ອນສ້າງກະແຈເຊື່ອມຕໍ່.',
  'Enable Mobile API in Add-ons before creating integration keys.':
    'ເປີດ Mobile API ໃນສ່ວນເສີມກ່ອນສ້າງກະແຈເຊື່ອມຕໍ່.',
  'Add an active member before creating integration keys.':
    'ເພີ່ມສະມາຊິກທີ່ໃຊ້ງານຢູ່ກ່ອນສ້າງກະແຈເຊື່ອມຕໍ່.',
  'API sections': 'ສ່ວນຈັດການ API',
  'API keys': 'ກະແຈ API',
  'API key': 'ກະແຈ API',
  'Connection guide': 'ຄູ່ມືເຊື່ອມຕໍ່',
  'Access activity': 'ປະຫວັດສິດເຂົ້າໃຊ້',
  'Key status summary': 'ສະຫຼຸບສະຖານະກະແຈ',
  'Active keys': 'ກະແຈທີ່ໃຊ້ງານຢູ່',
  'Expiring within 7 days': 'ໝົດອາຍຸພາຍໃນ 7 ມື້',
  'Unavailable keys': 'ກະແຈທີ່ໃຊ້ບໍ່ໄດ້',
  'Revoked keys': 'ກະແຈທີ່ຖືກຖອນ',
  keys: 'ກະແຈ',
  'Search keys, members or workspaces…': 'ຄົ້ນຫາກະແຈ, ສະມາຊິກ ຫຼື ທຸລະກິດ…',
  'All statuses': 'ທຸກສະຖານະ',
  expired: 'ໝົດອາຍຸ',
  revoked: 'ຖືກຖອນ',
  unavailable: 'ໃຊ້ບໍ່ໄດ້',
  Unavailable: 'ໃຊ້ບໍ່ໄດ້',
  'No keys on this page': 'ບໍ່ມີກະແຈໃນໜ້ານີ້',
  'No matching API keys': 'ບໍ່ພົບກະແຈ API ທີ່ກົງກັນ',
  'No API keys yet': 'ຍັງບໍ່ມີກະແຈ API',
  'Try another search or status filter.': 'ລອງຄົ້ນຫາຄຳອື່ນ ຫຼື ປ່ຽນຕົວກອງສະຖານະ.',
  'Create a scoped key to connect an authorized app to a workspace.':
    'ສ້າງກະແຈທີ່ຈຳກັດສິດເພື່ອເຊື່ອມຕໍ່ແອັບທີ່ອະນຸຍາດກັບທຸລະກິດ.',
  'First page': 'ໜ້າທຳອິດ',
  'Key / workspace': 'ກະແຈ / ທຸລະກິດ',
  'Access / member': 'ສິດ / ສະມາຊິກ',
  'Created / expires': 'ວັນສ້າງ / ວັນໝົດອາຍຸ',
  'Last used': 'ໃຊ້ລ່າສຸດ',
  'Never used': 'ຍັງບໍ່ເຄີຍໃຊ້',
  'Member removed': 'ສະມາຊິກຖືກລຶບ',
  'Expiring soon': 'ໃກ້ໝົດອາຍຸ',
  'Rotate key': 'ປ່ຽນກະແຈ',
  'Revoke key': 'ຖອນກະແຈ',
  'Key revoked': 'ຖອນກະແຈແລ້ວ',
  'API key created': 'ສ້າງກະແຈ API ແລ້ວ',
  'API key rotated': 'ປ່ຽນກະແຈ API ແລ້ວ',
  'Keys are shown once, hashed at rest, and expire within 90 days. Revocation takes effect immediately.':
    'ກະແຈສະແດງພຽງຄັ້ງດຽວ, ເກັບເປັນຄ່າແຮຊ ແລະ ໝົດອາຍຸພາຍໃນ 90 ມື້. ການຖອນກະແຈມີຜົນທັນທີ.',
  'Connect an application': 'ເຊື່ອມຕໍ່ແອັບ',
  'Use a bearer key and the workspace header on every business request. Keep keys on a trusted server or in secure device storage.':
    'ໃຊ້ກະແຈ Bearer ແລະ ຫົວຂໍ້ລະຫັດທຸລະກິດໃນທຸກຄຳຂໍ. ເກັບກະແຈໃນເຊີບເວີທີ່ເຊື່ອຖືໄດ້ ຫຼື ບ່ອນເກັບທີ່ປອດໄພໃນອຸປະກອນ.',
  'Request example': 'ຕົວຢ່າງຄຳຂໍ',
  'Access policy': 'ນະໂຍບາຍສິດເຂົ້າໃຊ້',
  'Reads permitted workspace data. Business changes are blocked.':
    'ອ່ານຂໍ້ມູນທຸລະກິດທີ່ອະນຸຍາດ. ບໍ່ສາມາດປ່ຽນແປງຂໍ້ມູນໄດ້.',
  'Allows changes permitted by the assigned member’s current role and enabled modules.':
    'ປ່ຽນແປງຂໍ້ມູນໄດ້ຕາມບົດບາດປັດຈຸບັນຂອງສະມາຊິກ ແລະ ໂມດູນທີ່ເປີດໃຊ້.',
  'Credential lifecycle': 'ອາຍຸການໃຊ້ກະແຈ',
  'Choose 7, 30 or 90 days. Rotating a key replaces it and immediately revokes the previous key.':
    'ເລືອກ 7, 30 ຫຼື 90 ມື້. ການປ່ຽນກະແຈຈະສ້າງກະແຈໃໝ່ ແລະ ຖອນກະແຈເກົ່າທັນທີ.',
  'Workspace isolation': 'ການແຍກທຸລະກິດ',
  'Keys cannot enter Control Center or access another workspace. Disabled members and suspended workspaces lose access.':
    'ກະແຈບໍ່ສາມາດເຂົ້າສູນຄວບຄຸມ ຫຼື ທຸລະກິດອື່ນ. ສະມາຊິກທີ່ປິດໃຊ້ ແລະ ທຸລະກິດທີ່ລະງັບຈະເສຍສິດເຂົ້າໃຊ້.',
  'View platform health': 'ເບິ່ງສະຖານະລະບົບ',
  'Recent access activity': 'ປະຫວັດສິດເຂົ້າໃຊ້ລ່າສຸດ',
  'No access activity yet': 'ຍັງບໍ່ມີປະຫວັດສິດເຂົ້າໃຊ້',
  'Key creation, rotation and revocation appear here.':
    'ການສ້າງ, ປ່ຽນ ແລະ ຖອນກະແຈຈະສະແດງຢູ່ທີ່ນີ້.',
  Key: 'ກະແຈ',
  Administrator: 'ຜູ້ດູແລລະບົບ',
  'Choose a workspace, member and the minimum access your integration needs.':
    'ເລືອກທຸລະກິດ, ສະມາຊິກ ແລະ ສິດທີ່ຈຳເປັນສຳລັບການເຊື່ອມຕໍ່.',
  'Integration access': 'ສິດເຊື່ອມຕໍ່',
  'Select a workspace': 'ເລືອກທຸລະກິດ',
  'Key name': 'ຊື່ກະແຈ',
  'Acts as member': 'ໃຊ້ສິດຂອງສະມາຊິກ',
  'The key follows this member’s current permissions.': 'ກະແຈຈະໃຊ້ສິດປັດຈຸບັນຂອງສະມາຊິກນີ້.',
  'Select a member': 'ເລືອກສະມາຊິກ',
  'Expires after': 'ໝົດອາຍຸຫຼັງ',
  days: 'ມື້',
  'Creating…': 'ກຳລັງສ້າງ…',
  'Working…': 'ກຳລັງດຳເນີນການ…',
  'Replacement expires after': 'ກະແຈໃໝ່ໝົດອາຍຸຫຼັງ',
  'The previous key stops working immediately. Copy the replacement and update your integration before closing this window.':
    'ກະແຈເກົ່າຈະໃຊ້ບໍ່ໄດ້ທັນທີ. ຄັດລອກກະແຈໃໝ່ ແລະ ອັບເດດການເຊື່ອມຕໍ່ກ່ອນປິດໜ້ານີ້.',
  'This key stops working immediately. Applications using it will lose access. This action cannot be undone.':
    'ກະແຈນີ້ຈະໃຊ້ບໍ່ໄດ້ທັນທີ. ແອັບທີ່ໃຊ້ກະແຈນີ້ຈະເສຍສິດເຂົ້າໃຊ້. ບໍ່ສາມາດຍົກເລີກການຖອນໄດ້.',
  'Keep this key private. It is not included in lists, logs or audit history.':
    'ເກັບກະແຈນີ້ເປັນຄວາມລັບ. ກະແຈຈະບໍ່ສະແດງໃນລາຍການ ຫຼື ປະຫວັດການໃຊ້ງານ.',
  'Unable to copy. Select and copy the text manually.':
    'ຄັດລອກບໍ່ໄດ້. ເລືອກຂໍ້ຄວາມແລ້ວຄັດລອກດ້ວຍຕົນເອງ.',
  'API & connections has moved': 'API ແລະ ການເຊື່ອມຕໍ່ຍ້າຍແລ້ວ',
  'API keys and integration access are managed centrally in Control Center.':
    'ຈັດການກະແຈ API ແລະ ສິດເຊື່ອມຕໍ່ໃນສູນຄວບຄຸມ.',
  'Open API & connections': 'ເປີດ API ແລະ ການເຊື່ອມຕໍ່',
  'Contact your platform administrator to manage integration access for this workspace.':
    'ຕິດຕໍ່ຜູ້ດູແລລະບົບເພື່ອຈັດການສິດເຊື່ອມຕໍ່ຂອງທຸລະກິດນີ້.',
};
